import React from 'react'
import { Pipeline } from '@morningtrain/react-helpers'
import * as Fields from 'support/fields'
import moment from 'moment'
import { ExecuteOperationOnPipe, Form, Operation, TriggerPipelineOnFormSubmit } from '@morningtrain/react-resources'
import * as UI from 'ui'
import ConfirmCancelEmploymentButton from 'pages/app/users/partials/ConfirmCancelEmploymentButton'
import { Fieldset } from 'layouts'
import { Translation } from '@morningtrain/react-translations'

export default function CancelEmploymentForm () {

  const [isDatePickerShown, setIsDatePickerShown] = React.useState(false)

  return (
          <Pipeline>
            <Operation namespace="api" resourceName="users" operationName="terminate">
              <Form submitTo="terminate" className="form-field">
                {!isDatePickerShown && (
                        <div className="form-element">
                          <div className="mt-6"></div>
                          <UI.Button color="red">
                            <UI.Text className="flex space-x-3 items-center" block
                                     onClick={() => setIsDatePickerShown(true)}>
                              <p><Translation name="hr.employments.actions.cancel"/></p>
                            </UI.Text>
                          </UI.Button>
                        </div>
                )}
                {isDatePickerShown && (
                        <Fieldset cols={2}>
                          <Fields.Date name="inactive_at" defaultValue={moment().format('YYYY-MM-DD hh:mm:ss')}/>
                          <div className="form-element">
                            <div className="mt-6"></div>
                            <UI.ButtonWrap leftAlign>
                              <UI.Button onClick={() => setIsDatePickerShown(false)}>
                                <UI.Text className="flex space-x-3 items-center" block>
                                  <p><Translation name="generic.cancel"/></p>
                                </UI.Text>
                              </UI.Button>
                              <ConfirmCancelEmploymentButton/>
                            </UI.ButtonWrap>
                          </div>
                        </Fieldset>
                )}
                <TriggerPipelineOnFormSubmit/>
                <ExecuteOperationOnPipe resourceName="users.users" operationName="read"
                                        operationContext={{ context: 'user_profile' }}/>
              </Form>
            </Operation>
          </Pipeline>
  )
}
